var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: {
          rules:
            _vm.obrigatorio && !_vm.value.length
              ? "min_items:1," + _vm.label
              : "",
          name: _vm.nomeAba + "/" + _vm.label
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c(
                  "el-col",
                  {
                    class: _vm.marginLeft ? "ml-forms" : "",
                    attrs: { span: _vm.widthColumn }
                  },
                  [
                    _c("Label", {
                      attrs: {
                        label: _vm.label,
                        obrigatorio: _vm.obrigatorio,
                        Indice: _vm.Indice
                      }
                    }),
                    _vm._v(" "),
                    _vm.vMask
                      ? _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: _vm.vMask,
                              expression: "vMask"
                            }
                          ],
                          staticClass: "input",
                          class: { "input erro": errors.length },
                          attrs: { name: _vm.label },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function() {
                                  return [
                                    _c("el-button", {
                                      staticClass: "style",
                                      attrs: {
                                        icon: "el-icon-plus",
                                        disabled:
                                          _vm.val.length <
                                          _vm.maxlengthButtonDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.add(_vm.val)
                                        }
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.val,
                            callback: function($$v) {
                              _vm.val = $$v
                            },
                            expression: "val"
                          }
                        })
                      : _c("el-input", {
                          staticClass: "input",
                          class: { "input erro": errors.length },
                          attrs: { name: _vm.label },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function() {
                                  return [
                                    _c("el-button", {
                                      staticClass: "style",
                                      attrs: {
                                        icon: "el-icon-plus",
                                        disabled:
                                          _vm.val.length <
                                          _vm.maxlengthButtonDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.add(_vm.val)
                                        }
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.val,
                            callback: function($$v) {
                              _vm.val = $$v
                            },
                            expression: "val"
                          }
                        }),
                    _vm._v(" "),
                    errors.length
                      ? _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tag-app-input",
                        staticStyle: { "margin-top": "4px" }
                      },
                      _vm._l(_vm.value, function(val, index) {
                        return _c(
                          "el-tag",
                          {
                            key: index,
                            staticStyle: {
                              "margin-right": "4px",
                              "margin-bottom": "4px"
                            },
                            attrs: {
                              closable: "",
                              type: "info",
                              size: "medium"
                            },
                            on: {
                              close: function($event) {
                                return _vm.remove(index)
                              }
                            }
                          },
                          [_vm._v("\n          " + _vm._s(val) + "\n        ")]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dd2beb1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dd2beb1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/InputMultiTexts/InputMultiTexts.vue
// module id = null
// module chunks = 